import { useMemoizedFn, useUnmount } from 'ahooks';
import useOperateDPSReport from './useOperateDPSReport';
import { getStorageReportTitle, getStorageReport, removeStorageReport, transform2MockIdBatch } from '../../utils';

import type { IDPSReportFormValue } from '../types';

export default function useEditDPSReport(props?: {
  // 获取当前周报的value
  getReport?: () => IDPSReportFormValue;
  // 设置当前周报的value
  setReport?: (payload: Partial<IDPSReportFormValue>) => void;
}) {
  const { getReport, setReport } = props || {};

  const reportTitle = getStorageReportTitle();
  const { report_id: reportId, start_date: startDate, end_date: endDate } = getStorageReport();

  const getInitialFilter = useMemoizedFn(() => ({ start_date: startDate, end_date: endDate }));

  const updateReportPage = useMemoizedFn(() => {
    const storageReport = getStorageReport();
    const { comment, hightlights, changes, miscellaneous, calendar } = storageReport || {};
    setReport?.({
      comment: comment || '',
      hightlights: transform2MockIdBatch(hightlights),
      changes: transform2MockIdBatch(changes),
      miscellaneous: transform2MockIdBatch(miscellaneous),
      calendar: transform2MockIdBatch(calendar),
    });
    setIsLoading(false);
  });

  const {
    isGuide,
    isLoading,
    setIsLoading,
    isHightlightsInnerLoading,
    isCalendarInnerLoading,
    isSubmitting,
    submitType,
    reportHelper,
    projectsMilestones,
    filter,
    onHightlightsRefreshData,
    onCalendarRefreshData,
    onSubmit,
  } = useOperateDPSReport({
    pageId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT',
    pageLogOthers: {
      uidType: 'dps_report_id',
      uid: reportId || '',
      extInfo: reportTitle || '',
    },
    confirmBtnId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT_CONFIRM_SUBMIT',
    publishBtnId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT_PUBLISH_SUBMIT',
    refreshHightlightsBtnId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT_REFRESH_HIGHTLIGHTS_SUBMIT',
    refreshCalendarBtnId: 'WORKSPACE_DPS_WEEKLY_REPORT_EDIT_REFRESH_CALENDAR_SUBMIT',
    getInitialFilter,
    updateReportPage,
    getReport,
    setReport,
  });

  useUnmount(() => {
    removeStorageReport();
  });

  return {
    isGuide,
    isLoading,
    isHightlightsInnerLoading,
    isCalendarInnerLoading,
    isSubmitting,
    submitType,
    reportHelper,
    projectsMilestones,
    filter,
    onHightlightsRefreshData,
    onCalendarRefreshData,
    onSubmit,
  };
}
